<div class="container m-b-20">
  <mat-card>
    <form [formGroup]="clientScreenReportForm" (ngSubmit)="generate()">
      <mat-card-content>
        <div>
          <mat-form-field fxFlex>
            <mat-label>{{ 'labels.inputs.Client Screen Reports' | translate }}</mat-label>
            <mat-select formControlName="templateId">
              <mat-option *ngFor="let template of templatesData" [value]="template.id">
                {{ template.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="clientScreenReportForm.controls.templateId.hasError('required')">
              {{ 'labels.inputs.Screen Report' | translate }} {{ 'labels.commons.is' | translate }}
              <strong>{{ 'labels.commons.required' | translate }}</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="5px">
        <button type="button" mat-raised-button [routerLink]="['../../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="!clientScreenReportForm.valid">
          <fa-icon icon="cogs" size="sm" class="m-r-10"></fa-icon>{{ 'labels.buttons.Generate Report' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>

<div #output class="container">
  <mat-card fxLayout="column" fxLayoutGap="3%">
    <div fxLayoutAlign="end">
      <button mat-stroked-button color="primary" [disabled]="!template" (click)="print()">
        <fa-icon icon="file" class="m-r-10"></fa-icon>
        {{ 'labels.buttons.Print' | translate }}
      </button>
    </div>

    <div #screenReport fxLayoutAlign="center">
      <p>{{ 'labels.text.Please select a screen report.' | translate }}</p>
    </div>
  </mat-card>
</div>
